import keycloakAxios from '@/services/axios';
import {GroupData} from '@/types/group';
import {emitGroupChangeEvent} from './change-observable';
import {store} from '@/redux-store/store';

export const getGroupById = async (groupId: string) => {
  let userId: string | undefined;
  try {
    const state = store.getState();
    if (state && state.auth && state.userInfos) {
      userId = state.userInfos.userInfos._id;
    }
  } catch {
    userId = undefined;
  }
  const response = await keycloakAxios.get(`group/${groupId}/id/${userId}`);

  if (response.status >= 300) {
    throw new Error(
      `Error getting group: Invalid status code: ${response.status}`
    );
  }

  emitGroupChangeEvent({
    type: 'change',
    data: response.data as GroupData
  });

  return response.data;
};
